// @flow

import * as React from 'react';
import {ButtonLink} from 'sail/Button';
import Group from 'sail/Group';
import Box from 'sail/Box';
import {Subheading} from 'sail/Text';
import {useAccount, useAnalytics, useLocation} from 'docs/data';
import {defineMessages, FormattedMessage} from 'react-intl';

import './RecommendedDocs.scss';

const messages = defineMessages({
  recommendedDocsHeaders: {
    id: 'docsShell.navigation.recommendedDocs',
    description:
      'This is the header for the recommended docs section (experimental)',
    defaultMessage: 'Related Guides',
  },
});

// TODO (mulan): Find a more permanent solution based on results of the experiment
const experimentLinks = {
  payments: {
    treatment: {
      'Fraud Teams': 'https://stripe.com/radar/fraud-teams',
      '3D Secure 2': 'https://stripe.com/guides/3d-secure-2',
      'Implement 3D Secure 2':
        'https://support.stripe.com/questions/implementing-3d-secure-2-for-strong-customer-authentication',
    },
    control: {
      'More Payment Scenarios':
        'https://stripe.com/docs/payments/more-payment-scenarios',
      'Payments Quickstart': 'https://stripe.com/docs/payments/quickstart',
      'How Cards Work': 'https://stripe.com/docs/payments/cards/overview',
    },
  },
  payouts: {
    treatment: {
      'More Payment Scenarios':
        'https://stripe.com/docs/payments/more-payment-scenarios',
      'How Cards Work': 'https://stripe.com/docs/payments/cards/overview',
      'Accept a Payment Synchronously':
        'https://stripe.com/docs/payments/accept-a-payment-synchronously',
    },
    control: {
      'Instant Payouts': 'https://stripe.com/docs/payouts/instant-payouts',
      'Testing Stripe Connect': 'https://stripe.com/docs/connect/testing',
      'The Payment Intents API':
        'https://stripe.com/docs/payments/payment-intents',
    },
  },
  testing: {
    treatment: {
      'Apps & Extensions': 'https://stripe.com/partners/apps-and-extensions',
      'Set Up Future Payments':
        'https://stripe.com/docs/payments/save-and-reuse',
      'Card Testing': 'https://stripe.com/docs/card-testing',
    },
    control: {
      'Test Payments': 'https://dashboard.stripe.com/test/payments',
      'Testing Stripe Connect': 'https://stripe.com/docs/connect/testing',
      'The Payment Intents API':
        'https://stripe.com/docs/payments/payment-intents',
    },
  },
};

export const ROUTE_TO_EXPERIMENT_GROUP = {
  '/docs/payments/accept-a-payment': 'payments',
  '/docs/payouts': 'payouts',
  '/docs/testing': 'testing',
};

export const RecommendedDocs = () => {
  const {account} = useAccount();
  const {trackAction} = useAnalytics();
  const {location} = useLocation();

  // treatments is null if the user is not logged in
  if (!account.treatments) {
    return null;
  }

  // First checks if user is in the treatment groups for the experiment
  // Previously treatments could be an empty object so we have to check
  // for the specific experiment
  const isInExperiment = account.treatments['docs_related_page_recommendations']
    ? account.treatments['docs_related_page_recommendations']
    : null;

  const experimentGroup = ROUTE_TO_EXPERIMENT_GROUP[location.pathname] || null;

  if (!isInExperiment || !experimentGroup) {
    return null;
  }

  const linkGroupLabels = Object.keys(
    experimentLinks[experimentGroup][isInExperiment],
  );
  const linkGroups = experimentLinks[experimentGroup][isInExperiment];

  return (
    <Box>
      <Subheading className="RecommendedDocs-header">
        <FormattedMessage {...messages.recommendedDocsHeaders} />
      </Subheading>
      <Group spacing={12}>
        <ButtonLink
          label={linkGroupLabels[0]}
          href={linkGroups[linkGroupLabels[0]]}
          target="_blank"
          onClick={() => {
            trackAction('docs_recommended_articles', {
              type: '0',
            });
          }}
        />
        <ButtonLink
          label={linkGroupLabels[1]}
          href={linkGroups[linkGroupLabels[1]]}
          target="_blank"
          onClick={() => {
            trackAction('docs_recommended_articles', {
              type: '1',
            });
          }}
        />
        <ButtonLink
          label={linkGroupLabels[2]}
          href={linkGroups[linkGroupLabels[2]]}
          target="_blank"
          onClick={() => {
            trackAction('docs_recommended_articles', {
              type: '2',
            });
          }}
        />
      </Group>
    </Box>
  );
};
